<!-- Button -->
<button
  mat-button
  class="touch-target inline-flex min-w-4 px-2"
  [matMenuTriggerFor]="languages"
  [attr.aria-label]="activeLang()"
>
  <ng-container *ngTemplateOutlet="flagImage; context: { $implicit: activeLang() }"></ng-container>
</button>

<!-- Language menu -->
<mat-menu [xPosition]="'before'" #languages="matMenu">
  @for (lang of availableLangs; track lang.id) {
    <button mat-menu-item (click)="setActiveLang(lang.id)">
      <span class="flex items-center">
        <ng-container *ngTemplateOutlet="flagImage; context: { $implicit: lang.id }"></ng-container>
        <span class="ml-3">{{ lang.label }}</span>
      </span>
    </button>
  }
</mat-menu>

<!-- Flag image template -->
<ng-template let-lang #flagImage>
  <span class="relative block w-6 overflow-hidden rounded-sm shadow">
    <span class="absolute inset-0 ring-1 ring-black/10 ring-inset"></span>
    <img class="block w-full" [src]="flagUrl(lang)" [alt]="'Flag image for ' + lang" />
  </span>
</ng-template>
